import React from 'react';
import { Section } from '../../../CampaignSideBar.styles';
import { AvailableIcons, TypographyVariant, Icon, TypographyType } from 'src/components-dummy';
import { CardTitleStyled } from './ProductCardSection.styles';
import { LinkButton } from 'src/components-dummy/LinkButton';

interface EmptyCardProps {
  onAdd: () => void;
}

export const EmptyCard = ({ onAdd }: EmptyCardProps): JSX.Element => {
  return (
    <Section>
      <CardTitleStyled type={TypographyType.Body} variant={TypographyVariant.SmallBold}>
        {`This product card doesn't display any content yet.`}
      </CardTitleStyled>
      <CardTitleStyled type={TypographyType.Body} variant={TypographyVariant.SmallRegular}>
        Add fields like product name, brand, or price to customize your card.
      </CardTitleStyled>
      <LinkButton onClick={onAdd}>
        <Icon name={AvailableIcons.Plus} /> Add another Field
      </LinkButton>
    </Section>
  );
};
